import st from "@/styles/UserSidebar.module.scss"
import clsx from "clsx";
import { useEffect, useLayoutEffect} from "react";
import {useAtom} from "jotai/index";
import {loan_sidebar_data, open_gen_dashboard_menu, open_notifications_sidebar} from "@/atoms/profile.ts";
import DashboardClass from "@/utils/dashboard_class";
import { useLocation} from 'react-router-dom';
import GeneralMenu from "@/components/SideElements/elems/GeneralMenu.tsx";
import SystemNotificationsSidebar from "@/components/SideElements/elems/SystemNotificationsSidebar.tsx";
import StepsInterface from "@/types_and_interfaces/sidebar_steps_interface.ts";
import CommonClass from "@/utils/common.ts";
import useNotifications from "@/hooks/notifications.ts";
import useCommon from "@/hooks/common.ts";


interface Props {
    steps?: Array<StepsInterface>
}

const DashboardSidebars:React.FC<Props> = ({steps}) => {
    const dc = DashboardClass
    const [openGenSideMenu, setOpenGenSideMenu] = useAtom(open_gen_dashboard_menu)
    const [openNotifSideMenu] = useAtom(open_notifications_sidebar)
    const [applyData] = useAtom(loan_sidebar_data)
    const notif = useNotifications()
    const {removeScrollability} = useCommon()
    const location = useLocation();
    
    
    useLayoutEffect(() => {
        let data = localStorage.getItem(CommonClass.local_storage_fields.cr_line_apply)
        
        if(data !== null && typeof applyData === "undefined") {
            // setApplyData(JSON.parse(data))
        }
        
    }, []);
    
    useEffect(() => {
        setOpenGenSideMenu(false)
        if(location.pathname.length) {
            if(location.pathname !== dc.dashboard_routes.ApplyCrLine) {
                // setApplyData(undefined)
            }
        }
        
    }, [location]);
    
    useEffect(() => {
        if(openGenSideMenu) {
            removeScrollability(openGenSideMenu)
        } else  removeScrollability(openGenSideMenu)
    }, [openGenSideMenu])
    
    
    return (
        <div className={clsx(
            st.user_sidebar,
            (openGenSideMenu || openNotifSideMenu) && st.active,
            openNotifSideMenu && st.notif_active
        )}>
            
            <div
                className={clsx(st.overlay)}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpenGenSideMenu(false)
                    if(openNotifSideMenu) {
                        notif.notification_sidebar_handle()
                    }
                }}
            />
            
            <GeneralMenu steps={steps} />
            
            <SystemNotificationsSidebar />
        
        </div>
    )
}





export default DashboardSidebars